import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * When the PWA is launched from the home screen (display-mode: standalone),
 * redirect the user straight to /schedule the first time they open a session.
 * Users can still navigate back to "/" manually after.
 */
export default function StandaloneRedirect() {
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    const isStandalone =
      window.matchMedia?.("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    if (!isStandalone) return;
    // Only do this once per session, and only if they're landing on "/"
    const seen = sessionStorage.getItem("link_standalone_routed");
    if (!seen && loc.pathname === "/") {
      sessionStorage.setItem("link_standalone_routed", "1");
      nav("/schedule", { replace: true });
    }
  }, [nav, loc.pathname]);

  return null;
}
